
export default function ({ isServer, req, redirect, route }) {
    let pcOrigin = 'http://starsgames.cn'
    let mobileOrigin = 'http://m.starsgames.cn'
    let isMobile = (ua) => {
        return !!ua.match(/AppleWebKit.*Mobile.*/)
    }
    let userAgent = req ? req.headers['user-agent'] : navigator.userAgent || ''
    if (isMobile(userAgent) && !route.query.beta) {
        return redirect(mobileOrigin + route.fullPath)
    }

    // return isMobile(userAgent) ? redirect(mobileOrigin + route.fullPath) : redirect(pcOrigin + route.fullPath) //这种会重定向错误
    // 使用redirect 重定向到外链需要加上前缀:http / https
}
